module.exports = __webpack_public_path__ + "img/1.647fa1c6.jpg";